/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { noopFn } from '../../../../Utilities/propHelpers/defaultProps.js';

var _excluded = ["id", "classNames", "ariaHidden", "children", "setActivePanelById"];
var SidePanelMultiStep = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$id = props.id,
    id = _props$id === void 0 ? 'side-panel-multi-step' : _props$id,
    classNames = props.classNames,
    ariaHidden = props.ariaHidden,
    children = props.children,
    _props$setActivePanel = props.setActivePanelById,
    setActivePanelById = _props$setActivePanel === void 0 ? noopFn : _props$setActivePanel,
    rest = _objectWithoutProperties(props, _excluded);
  var nestedPanelReactContent = null;
  if (children && children.props.children) {
    // if it is a react element
    if ( /*#__PURE__*/React.isValidElement(children.props.children)) {
      nestedPanelReactContent = /*#__PURE__*/React.cloneElement(children.props.children, {
        setActivePanelById: setActivePanelById
      });
    }
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    className: classNames,
    "aria-hidden": ariaHidden,
    ref: ref
  }, rest), nestedPanelReactContent || children);
});
SidePanelMultiStep.propTypes = {
  children: PropTypes.node,
  classNames: PropTypes.string,
  id: PropTypes.string,
  ariaHidden: PropTypes.string,
  setActivePanelById: PropTypes.func
};
var SidePanelMultiStep$1 = SidePanelMultiStep;

export { SidePanelMultiStep$1 as default };
